import {Component, Input} from '@angular/core';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {LegalEntity} from '../../../../domain/core/legal-entity.model';

@Component({
  selector: 'app-blacklist',
  imports: [],
  templateUrl: './blacklist.component.html'
})
export class BlacklistComponent {
  @Input() brand: VehicleBrand;
  @Input() legalEntity: LegalEntity;
}
